import { render, staticRenderFns } from "./devices.vue?vue&type=template&id=8c767fb6"
import script from "./devices.vue?vue&type=script&lang=js"
export * from "./devices.vue?vue&type=script&lang=js"
import style0 from "./devices.vue?vue&type=style&index=0&id=8c767fb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports